import React, { useState, useEffect, useRef } from 'react';
import '../css/notificationButton.css';
import { BellIcon } from '../../../../../../asset-controller-mod/asset-serv/icons/iconExporter';

export interface NotificationButtonProps {
  count?: number;
  onClick?: () => void;
  active?: boolean;
}

const NotificationButton: React.FC<NotificationButtonProps> = ({
  count = 0,
  onClick,
  active = false,
}) => {
  const [hovered, setHovered] = useState(false);
  const [displayCount, setDisplayCount] = useState(count);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

   /* istanbul ignore next */
  useEffect(() => {
    timerRef.current = setTimeout(() => {
      setDisplayCount(count);
    }, 5000);

    return () => {
       /* istanbul ignore next */
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [count]);

  return (
    <button
      type="button"
      className={`scl--cms-components-notifBtn${active ? ' scl--cms-components-notifBtn--active' : ''}`}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      aria-label={`Notifications${displayCount > 0 ? `, ${displayCount} unread` : ''}`} //NOSONAR
    >
      <BellIcon hovered={hovered} active={active} />

      {displayCount > 0 && (
        <span className="scl--cms-components-notifBtn-badge">
          {displayCount > 99 ? '99+' : displayCount}
        </span>
      )}
    </button>
  );
};

export default NotificationButton;